// Iter 148 — Streamer-only Live Support card. Sits above the async ticket
// list so streamers can jump straight to our Discord server for real-time
// help. Frontend only, no backend/routing/auth impact.
//
// Not rendered on player or admin dashboards by design.
//
// Iter 207 — All visible strings wired through i18n (`liveSupport.*`).
import { useI18n } from "../lib/i18n";

const DISCORD_URL = "https://discord.gg/Y66jDG695";

// Discord brand glyph — lucide-react has no Discord icon, so we inline the
// simplified official mark. Sized to match the neighbouring lucide icons.
function DiscordGlyph({ className = "w-5 h-5" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M20.317 4.369A19.79 19.79 0 0 0 16.558 3.2a.075.075 0 0 0-.079.037c-.34.607-.719 1.4-.985 2.028a18.27 18.27 0 0 0-5.487 0 12.51 12.51 0 0 0-1.001-2.028.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 5.164 4.37a.07.07 0 0 0-.032.028C2.71 8.02 2.05 11.577 2.376 15.09a.083.083 0 0 0 .031.056 19.9 19.9 0 0 0 5.993 3.033.077.077 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.995a.076.076 0 0 0-.041-.105 13.1 13.1 0 0 1-1.872-.892.077.077 0 0 1-.008-.127c.126-.094.252-.192.372-.291a.075.075 0 0 1 .078-.01c3.927 1.793 8.18 1.793 12.061 0a.075.075 0 0 1 .079.009c.12.099.246.198.372.292a.077.077 0 0 1-.006.127c-.598.35-1.22.65-1.873.891a.076.076 0 0 0-.04.106c.36.7.772 1.363 1.225 1.994a.076.076 0 0 0 .084.028 19.876 19.876 0 0 0 6.002-3.032.077.077 0 0 0 .031-.055c.5-4.087-.838-7.614-3.548-10.694a.061.061 0 0 0-.031-.028zM8.02 12.94c-1.183 0-2.157-1.085-2.157-2.418 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.332-.955 2.417-2.157 2.417zm7.974 0c-1.183 0-2.157-1.085-2.157-2.418 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.332-.946 2.417-2.157 2.417z" />
    </svg>
  );
}

export default function StreamerLiveSupportCard() {
  const { t } = useI18n();
  return (
    <section
      className="mt-10 border border-[#2DD4A7]/40 bg-[#2DD4A7]/[0.05] p-5 sm:p-6"
      data-testid="streamer-live-support-card"
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-start gap-3">
          <div className="shrink-0 w-10 h-10 flex items-center justify-center border border-[#2DD4A7]/50 text-[#2DD4A7]">
            <DiscordGlyph />
          </div>
          <div>
            <div className="text-[10px] font-mono uppercase tracking-widest text-[#2DD4A7] mb-0.5">
              {t("liveSupport.eyebrow")}
            </div>
            <h3 className="font-display text-lg font-bold tracking-tight text-[#E8ECF4]">
              {t("liveSupport.title")}
            </h3>
            <p className="text-xs text-[#8B97AE] mt-1 max-w-md">
              {t("liveSupport.desc")}
            </p>
          </div>
        </div>
        <a
          data-testid="streamer-live-support-discord-link"
          href={DISCORD_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-5 h-10 bg-[#2DD4A7] text-[#04150F] text-xs font-mono uppercase tracking-widest hover:bg-[#F5B841] transition-colors shrink-0"
        >
          <DiscordGlyph className="w-4 h-4" />
          {t("liveSupport.cta")}
        </a>
      </div>
    </section>
  );
}
